import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IChecklistTemplateDetailPost,
  IResponse,
  IChecklistTemplate,
  IChecklistType,
  ITaskType,
  ISageTask,
  ICreateSageTask,
  IChecklistTemplateDetail,
  IChecklistTemplateWorkItemCategory,
  IChecklistTemplateRequirementType
} from '../models';

export const getChecklistTemplates = async (filters?: {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: string;
  name?: string;
  typeId?: string | number;
}): Promise<IResponse<IChecklistTemplate[]>> => {
  try {
    const { data } = await axios.get(`/api/checklist-templates`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getChecklistTemplates failed');
    return Promise.reject(error);
  }
};

export const getChecklistTypes = async (filters?: {
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: string;
  name?: string;
}): Promise<IResponse<IChecklistType[]>> => {
  try {
    const { data } = await axios.get(`/api/checklist-types`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getChecklistTypes failed');
    return Promise.reject(error);
  }
};

export const getTaskTypes = async (filters?: {
  taskTypeNumber?: number;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IResponse<ITaskType[]>> => {
  try {
    const { data } = await axios.get(`/api/tasks/task-types`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getTaskTypes failed');
    return Promise.reject(error);
  }
};

export const getTasks = async (filters?: {
  taskNumber?: number;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IResponse<ISageTask[]>> => {
  try {
    const { data } = await axios.get(`/api/tasks`, { params: filters });
    return data;
  } catch (error) {
    logError(error, 'getTasks failed');
    return Promise.reject(error);
  }
};

export const createTask = async (post: ICreateSageTask) => {
  try {
    const { data } = await axios.post(`/api/tasks`, post);
    return data;
  } catch (error: any) {
    logError(
      {
        error,
        payload: post
      },
      'createTask failed'
    );
    return error.response.data;
  }
};

export const getChecklistTemplate = async (id: number): Promise<IChecklistTemplateDetail> => {
  try {
    const { data } = await axios.get(`/api/checklist-templates/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getChecklistTemplate failed');
    return Promise.reject(error);
  }
};

export const deleteChecklistTemplate = async (id: number) => {
  try {
    const { data } = await axios.delete(`/api/checklist-templates/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteChecklistTemplate failed');
    return Promise.reject(error);
  }
};

export const createChecklistTemplate = async (post: IChecklistTemplateDetailPost) => {
  try {
    const { data } = await axios.post(`/api/checklist-templates`, post);
    return data;
  } catch (error: any) {
    logError(
      {
        error,
        payload: post
      },
      'createChecklistTemplate failed'
    );
    return error.response.data;
  }
};

export const updateChecklistTemplate = async (id: number | string, update: IChecklistTemplateDetailPost) => {
  try {
    const { data } = await axios.put(`/api/checklist-templates/${id}`, update);
    return data;
  } catch (error: any) {
    logError(
      {
        error,
        payload: update
      },
      'updateChecklistTemplate failed'
    );
    return error.response.data;
  }
};

export const getChecklistTemplatesWorkItemCategories = async (): Promise<IResponse<IChecklistTemplateWorkItemCategory[]>> => {
  try {
    const { data } = await axios.get(`/api/checklist-templates/work-items/categories`);
    return data;
  } catch (error) {
    logError(error, 'getChecklistTemplatesWorkItemCategories failed');
    return Promise.reject(error);
  }
};

export const createChecklistTemplatesWorkItemCategory = async (post: { name: string }): Promise<number> => {
  try {
    const { data } = await axios.post(`/api/checklist-templates/work-items/categories`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createChecklistTemplatesWorkItemCategory failed'
    );
    return Promise.reject(error);
  }
};

export const getChecklistTemplatesRequirementTypes = async (): Promise<IResponse<IChecklistTemplateRequirementType[]>> => {
  try {
    const { data } = await axios.get(`/api/checklist-templates/requirement-types`);
    return data;
  } catch (error) {
    logError(error, 'getChecklistTemplatesRequirementTypes failed');
    return Promise.reject(error);
  }
};
